import { Popper, Snackbar, Typography } from "@mui/material";
import { addHours, format } from "date-fns";
import {
  getDateTimeLocale,
  getDateTimeFormats,
} from "../../../../../utils/get-date-time-locale";

import React, { useCallback, useState, useMemo } from "react";
import { AiOutlineLink } from "react-icons/ai";
import { FiX } from "react-icons/fi";
import {
  CloseButton,
  CloseCopiedLinkPopoverButton,
  Container,
  CopyFileLinkButton,
  CopyLinkButtonContainer,
  FilePropertiesContainer,
  FilePropertyRow,
  FilePropertyText,
  FilePropertyTitle,
  Header,
} from "./styles";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  title: {
    fontSize: "1.2rem",
    fontWeight: "bold",
  },
});

const FilePropertiesPopover = ({ t, open, anchorEl, close, fileInfo }) => {
  const classes = useStyles();
  const { i18n } = useTranslation();

  const companiesNames = useMemo(() => {
    return (
      fileInfo?.companies?.map((company) => {
        return company.companyName;
      }) || []
    );
  }, [fileInfo]);

  const [copiedLinkMessageOpened, setCopiedLinkMessageOpened] = useState(false);

  // const FILE_MANAGEMENT_URL = `${process.env.WEB_URL}/fileManagement/`
  const FILE_MANAGEMENT_URL = `${window.location.origin}/`;

  const handleCopyLink = useCallback(() => {
    const fileLink = `${FILE_MANAGEMENT_URL}fileManagement?fileId=${fileInfo.id}`;

    navigator.clipboard.writeText(fileLink);

    setCopiedLinkMessageOpened(true);
  }, [fileInfo, FILE_MANAGEMENT_URL]);

  const fileCopiedSnackbarActions = (
    <CloseCopiedLinkPopoverButton
      onClick={() => setCopiedLinkMessageOpened(false)}
    >
      <FiX />
    </CloseCopiedLinkPopoverButton>
  );

  return (
    <>
      <Popper
        open={open}
        anchorEl={anchorEl}
        style={{ minWidth: "400px", maxWidth: "500px" }}
      >
        <Container>
          <Header>
            <Typography className={classes.title} nowrap>
              {t("menu.fileManagement.info.fileInfos")}
            </Typography>

            <CloseButton onClick={() => close()}>
              <FiX size={24} color="#212121" />
            </CloseButton>
          </Header>

          <FilePropertiesContainer>
            <FilePropertyRow>
              <FilePropertyTitle>{`${t(
                "menu.fileManagement.info.fileName"
              )}: `}</FilePropertyTitle>
              <FilePropertyText>{fileInfo.displayName}</FilePropertyText>
            </FilePropertyRow>

            <FilePropertyRow>
              <FilePropertyTitle>{`${t(
                "menu.fileManagement.info.fileType"
              )}: `}</FilePropertyTitle>
              <FilePropertyText>{fileInfo.extension}</FilePropertyText>
            </FilePropertyRow>

            <FilePropertyRow>
              <FilePropertyTitle>{`${t(
                "menu.fileManagement.info.creationUser"
              )}: `}</FilePropertyTitle>
              <FilePropertyText>{fileInfo.creatorUserName}</FilePropertyText>
            </FilePropertyRow>

            <FilePropertyRow>
              <FilePropertyTitle>{`${t(
                "menu.fileManagement.info.creationDate"
              )}: `}</FilePropertyTitle>
              <FilePropertyText>
                {format(
                  addHours(new Date(fileInfo.creationDate), -3),
                  getDateTimeFormats(i18n.language),
                  { locale: getDateTimeLocale(i18n.language) }
                )}
              </FilePropertyText>
            </FilePropertyRow>

            <FilePropertyRow>
              <FilePropertyTitle>{`${t(
                "menu.fileManagement.info.deletionUser"
              )}: `}</FilePropertyTitle>
              <FilePropertyText>{fileInfo.exclusionUserName}</FilePropertyText>
            </FilePropertyRow>

            <FilePropertyRow>
              <FilePropertyTitle>{`${t(
                "menu.fileManagement.info.deletionDate"
              )}: `}</FilePropertyTitle>
              <FilePropertyText>
                {fileInfo.exclusionDate
                  ? format(
                      addHours(new Date(fileInfo.exclusionDate), -3),
                      getDateTimeFormats(i18n.language),
                      { locale: getDateTimeLocale(i18n.language) }
                    )
                  : ""}
              </FilePropertyText>
            </FilePropertyRow>

            <FilePropertyRow>
              <FilePropertyTitle>
                {t("menu.fileManagement.info.companies")}
              </FilePropertyTitle>
              <FilePropertyText>{companiesNames.join(", ")}</FilePropertyText>
            </FilePropertyRow>

            <CopyLinkButtonContainer>
              <CopyFileLinkButton onClick={handleCopyLink}>
                <AiOutlineLink style={{ marginRight: "8px" }} />

                {t("meeting.copyLink")}
              </CopyFileLinkButton>
            </CopyLinkButtonContainer>
          </FilePropertiesContainer>
        </Container>
      </Popper>

      <Snackbar
        open={copiedLinkMessageOpened}
        autoHideDuration={2000}
        severity="success"
        onClose={() => setCopiedLinkMessageOpened(false)}
        message={t("linkCopied")}
        action={fileCopiedSnackbarActions}
      />
    </>
  );
};

export default FilePropertiesPopover;
